import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { publish } from "../../../GlobalFunctions/customEvent";
import { UpdateMetaThemeColour } from "../../../Utils/UpdateMetaThemeColour";
import { returnBackgroundColour } from "../../../Utils/returnBackgroundColour";
import { useAtom } from "jotai";
import { isElectronAtom } from "../../../-Atoms";

const showDock = () => {
  publish("showDock");
};

const CloseButton = ({ setEventDataModalOpen, canCloseModal = true }) => {
  const [isElectron] = useAtom(isElectronAtom);
  
  return (
    <div
      style={{
        position: "absolute",
        top: 12,
        left: 5,
        zIndex: 99999,
        "-webkit-app-region": "no-drag",
        "app-region": "no-drag",
        appRegion: "no-drag",
      }}
    >
      <IconButton
        onClick={() => {
          if (canCloseModal) {
            setEventDataModalOpen(false);
            showDock();
            UpdateMetaThemeColour({
              light: returnBackgroundColour("light"),
              dark: returnBackgroundColour("dark"),
            });
            
            if (isElectron) {
              window.ipcRenderer?.send("eval", "setCalendarWindowBounds()");
            }
          } else {
            document.activeElement.blur();
          }
        }}
        sx={{
          opacity: canCloseModal ? 1 : 0.5,
          transition: "opacity 0.2s ease",
        }}
      >
        <CloseIcon />
      </IconButton>
    </div>
  );
};

export default CloseButton;
